import { storiesQueryOptions } from "@/api/stories.api";
import { Stories } from "@/components/stories";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/stories")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(storiesQueryOptions),
  component: Stories,
});
